/* @flow */
import pubsub from './pubsub';

export interface State {
    title: string;
    Population: string;
    code: string;
}

// prettier-ignore
export const stateFactoids = {
    "AL": { title: "Alabama", "Population": "4,887,871", "Growth since 2010": "2.3%", "Settled": "1702", "Declared": "1819" },
    "AK": { title: "Alaska", "Population": "737,438", "Growth since 2010": "3.8%", "Settled": "1784", "Declared": "1959" },
    "AZ": { title: "Arizona", "Population": "7,171,646", "Growth since 2010": "12.2%", "Settled": "1776", "Declared": "1912" },
    "AR": { title: "Arkansas", "Population": "3,013,825", "Growth since 2010": "3.4%", "Settled": "1686", "Declared": "1836" },
    "CA": { title: "California", "Population": "39,865,590", "Growth since 2010": "6.98%", "Settled": "1769", "Declared": "1850" },
    "CO": { title: "Colorado", "Population": "5,695,564", "Growth since 2010": "13.2%", "Settled": "1858", "Declared": "1876" },
    "CT": { title: "Connecticut", "Population": "3,572,665", "Growth since 2010": "-0.04%", "Settled": "1634", "Declared": "1788" },
    "DE": { title: "Delaware", "Population": "967,171", "Growth since 2010": "7.7%", "Settled": "1638", "Declared": "1787" },
    "FL": { title: "Florida", "Population": "21,299,325", "Growth since 2010": "13.3%", "Settled": "1565", "Declared": "1845" },
    "GA": { title: "Georgia", "Population": "10,519,475", "Growth since 2010": "8.6%", "Settled": "1733", "Declared": "1788" },
    "HI": { title: "Hawaii", "Population": "1,420,491", "Growth since 2010": "4.4%", "Settled": "1820", "Declared": "1959" },
    "ID": { title: "Idaho", "Population": "1,754,208", "Growth since 2010": "11.9%", "Settled": "1842", "Declared": "1890" },
    "IL": { title: "Illinois", "Population": "12,741,080", "Growth since 2010": "-0.7%", "Settled": "1720", "Declared": "1818" },
    "IN": { title: "Indiana", "Population": "6,691,878", "Growth since 2010": "3.2%", "Settled": "1733", "Declared": "1816" },
    "IA": { title: "Iowa", "Population": "3,156,145", "Growth since 2010": "3.6%", "Settled": "1788", "Declared": "1846" },
    "KS": { title: "Kansas", "Population": "2,911,505", "Growth since 2010": "2.0%", "Settled": "1727", "Declared": "1861" },
    "KY": { title: "Kentucky", "Population": "4,468,402", "Growth since 2010": "3.0%", "Settled": "1774", "Declared": "1792" },
    "LA": { title: "Louisiana", "Population": "4,659,978", "Growth since 2010": "2.8%", "Settled": "1699", "Declared": "1812" },
    "ME": { title: "Maine", "Population": "1,338,404", "Growth since 2010": "0.8%", "Settled": "1624", "Declared": "1820" },
    "MD": { title: "Maryland", "Population": "6,042,718", "Growth since 2010": "4.7%", "Settled": "1634", "Declared": "1788" },
    "MA": { title: "Massachusetts", "Population": "6,902,149", "Growth since 2010": "5.4%", "Settled": "1620", "Declared": "1788" },
    "MI": { title: "Michigan", "Population": "9,995,915", "Growth since 2010": "1.1%", "Settled": "1668", "Declared": "1837" },
    "MN": { title: "Minnesota", "Population": "5,611,179", "Growth since 2010": "5.8%", "Settled": "1805", "Declared": "1858" },
    "MS": { title: "Mississippi", "Population": "2,986,530", "Growth since 2010": "0.6%", "Settled": "1699", "Declared": "1817" },
    "MO": { title: "Missouri", "Population": "6,126,452", "Growth since 2010": "2.3%", "Settled": "1735", "Declared": "1821" },
    "MT": { title: "Montana", "Population": "1,062,305", "Growth since 2010": "7.4%", "Settled": "1809", "Declared": "1889" },
    "NE": { title: "Nebraska", "Population": "1,929,268", "Growth since 2010": "5.6%", "Settled": "1823", "Declared": "1867" },
    "NV": { title: "Nevada", "Population": "3,034,392", "Growth since 2010": "12.4%", "Settled": "1849", "Declared": "1864" },
    "NH": { title: "New Hampshire", "Population": "1,356,458", "Growth since 2010": "3.0%", "Settled": "1623", "Declared": "1788" },
    "NJ": { title: "New Jersey", "Population": "8,908,520", "Growth since 2010": "1.3%", "Settled": "1660", "Declared": "1787" },
    "NM": { title: "New Mexico", "Population": "2,095,428", "Growth since 2010": "1.8%", "Settled": "1610", "Declared": "1912" },
    "NY": { title: "New York", "Population": "19,542,209", "Growth since 2010": "0.8%", "Settled": "1614", "Declared": "1788" },
    "NC": { title: "North Carolina", "Population": "10,383,620", "Growth since 2010": "8.9%", "Settled": "1660", "Declared": "1789" },
    "ND": { title: "North Dakota", "Population": "760,077", "Growth since 2010": "13.0%", "Settled": "1812", "Declared": "1889" },
    "OH": { title: "Ohio", "Population": "11,689,442", "Growth since 2010": "1.3%", "Settled": "1788", "Declared": "1803" },
    "OK": { title: "Oklahoma", "Population": "3,943,079", "Growth since 2010": "5.1%", "Settled": "1889", "Declared": "1907" },
    "OR": { title: "Oregon", "Population": "4,190,713", "Growth since 2010": "9.4%", "Settled": "1811", "Declared": "1859" },
    "PA": { title: "Pennsylvania", "Population": "12,807,060", "Growth since 2010": "0.8%", "Settled": "1682", "Declared": "1787" },
    "RI": { title: "Rhode Island", "Population": "1,057,315", "Growth since 2010": "0.5%", "Settled": "1636", "Declared": "1790" },
    "SC": { title: "South Carolina", "Population": "5,084,127", "Growth since 2010": "9.9%", "Settled": "1670", "Declared": "1788" },
    "SD": { title: "South Dakota", "Population": "882,235", "Growth since 2010": "8.4%", "Settled": "1859", "Declared": "1889" },
    "TN": { title: "Tennessee", "Population": "6,770,010", "Growth since 2010": "6.7%", "Settled": "1769", "Declared": "1796" },
    "TX": { title: "Texas", "Population": "29,206,997", "Growth since 2010": "15.86%", "Settled": "1682", "Declared": "1845" },
    "UT": { title: "Utah", "Population": "3,161,105", "Growth since 2010": "14.4%", "Settled": "1847", "Declared": "1896" },
    "VT": { title: "Vermont", "Population": "626,299", "Growth since 2010": "0.09%", "Settled": "1724", "Declared": "1791" },
    "VA": { title: "Virginia", "Population": "8,517,685", "Growth since 2010": "6.5%", "Settled": "1607", "Declared": "1788" },
    "WA": { title: "Washington", "Population": "7,535,591", "Growth since 2010": "12.1%", "Settled": "1811", "Declared": "1889" },
    "WV": { title: "West Virginia", "Population": "1,805,832", "Growth since 2010": "-2.5%", "Settled": "1727", "Declared": "1863" },
    "WI": { title: "Wisconsin", "Population": "5,813,568", "Growth since 2010": "2.2%", "Settled": "1766", "Declared": "1848" },
    "WY": { title: "Wyoming", "Population": "577,737", "Growth since 2010": "2.5%", "Settled": "1834", "Declared": "1890" },
}

// map element ids to their descriptions, tooltip will then display them
// prettier-ignore
const descriptions = {
    'logo': 'Return to main page.',
    'login-btn': 'Login / Sign-Up for free account.',
    'profile-btn': 'View user profile.',
    'search-field': 'Search for address, zipcode, or a marker you created earlier (use prefixes marker/zip/state/city folllowed by colon to narrow your search).',
    'clear-search': 'Reset search.',
    'search-btn': 'Start search.',
    'show-onboard-metrics': 'Show me how to use metric controls.',
    'show-onboard-region': 'Show me how to use region dashboard.',

    'individual-features-title': 'Select one or more metrics to generate a heat map showing which areas fit your criteria best. Some metrics are rank-based (i.e. median income) and some are categorical (i.e. housing heat by type).',
    'leaflet-controls-title': 'Controls for marking locations and interacting with the map.',

    'show-social-btns': 'Share this page',
    'facebook': 'Share on Facebook.',
    'twitter': 'Share on Twitter.',
    'reddit': 'Share on Reddit.',
    'linkedin': 'Share on LinkedIn.',
    'share-via-email': 'E-Mail this to a friend.',
    'share-img-btn': 'Share an image of this map.',

    // analytics tab
    'analytics-digital': 'Generate digital rental applications, agreements, invoices, and more. Then use them to track your income and expenses automatically.',
    'analytics-survey': 'Create surveys for your tenants, applicants, contractors, and customers. Integrate them seemlessly into your services.',
    'analytics-trends': 'Subscribe to our analysis of area trends and demographics patterns, and stay up to date on changes relevant to you.',

    // complex stats
    'selected_stats_title': 'This area shows the metrics you currently have selected for your query.',
    'year_selected': 'Choose a year you want to compute/predict metrics for. Dates in the future (2019+) and too far back (before 1990) are predicted, and their estimate may not be accurate.',
    'compute-stats-btn': "When you finish selecting metrics you're interested in, press the compute button to analyze selected geography.",
    'available_stats_title': 'This area shows all available metrics you can add to your query.',
    'find_metric': 'Search for a metric to add to your query.',

    // map controls
    'cities_toggle': 'Show city locations and relative sizes on the map.',
    'markers_toggle': 'Show all of the personal markers tied to your account on the map (these include the markers you created yourself, and purchased in the Marketplace).',
    'add-location': 'Mark a new location on the map.',
    'transportation_toggle': 'Show all routes you created or inherited via purchased markers.',
    'add-route': 'Calculate distance or show optimal route between 2 points or markers.',

    // legend
    'category-legend-close': 'Hide Legend',
    'category-legend-expand': 'Show Legend',

    // tooltip
    'state-tooltip-close': 'Deselect',

    // timeline
    'timeline-year': 'Change the year currently in view, or interact with the timeline.',
    'close-timeline': 'Hide timeline.',
    'timeline-bwd': 'Back in time.',
    'timeline-fwd': 'Forward in time.',
    'timeline-slider-dragbar': 'Drag slider to change current year or delta window.',
    'timeline-slider-delta-left': 'Drag left to create a delta comparison of several years.',
    'timeline-slider-delta-right': 'Drag right to create a delta comparison of several years.',
};

// prettier-ignore
const broadDescriptions = {
    'query-slider': 'Adjust weight from -100 (lower value desired) to 100 (higher value desired).'
};

// define which elements won't raise an error if missing on page
const allowMissing = [
    'login-btn',
    'profile-btn'
];

// apply tooltips
const page = document.querySelector("body");
const tooltip = document.getElementById("tooltip");
const stateTooltip = document.getElementById("state-tooltip"); // it often gets in the way, let's hide it when rendering this tooltip

let showTooltipForElement = (element: HTMLElement, message: string) => {
    let rect = element.getBoundingClientRect();
    let pageRect = page.getBoundingClientRect();
    tooltip.innerText = message;
    if (pageRect.width - rect.left < 120) {
        tooltip.style.right = (pageRect.width - rect.right) + "px";
    } else {
        tooltip.style.left = rect.left + "px";
    }
    if (pageRect.height - rect.bottom < 100) {
        tooltip.style.bottom = pageRect.height - rect.top + "px";
    } else {
        tooltip.style.top = rect.bottom + "px";
    }
    tooltip.style.display = "block";
    if (stateTooltip && !stateTooltip.classList.contains('static')) {
        stateTooltip.style.display = ""; // often gets in the way
    }
    element.addEventListener("mouseout", (event: MouseEvent) => {
        tooltip.style.top = "";
        tooltip.style.bottom = "";
        tooltip.style.left = "";
        tooltip.style.right = "";
        tooltip.style.display = "";
    });
};
let createTooltipForElement = (element: HTMLElement, message: string) => {
    let descriptions = [message]
    Object.keys(broadDescriptions).forEach(cls => {
        if (element.classList.contains(cls)) {
            descriptions.push(broadDescriptions[cls]);
        }
    });
    element.addEventListener("mouseover", (event: MouseEvent) => {
        event.stopPropagation()
        let rect = element.getBoundingClientRect();
        let pageRect = page.getBoundingClientRect();
        tooltip.innerText = descriptions.join("\n");
        // let minTooltipWidth = 
        if (pageRect.width - rect.left < 120) {
            // move tooltip left near right border
            tooltip.style.right = (pageRect.width - rect.right) + "px";
        } else {
            tooltip.style.left = rect.left + "px";
        }
        if (pageRect.height - rect.bottom < 100) {
            // move tooltip up near the bottom
            tooltip.style.bottom = pageRect.height - rect.top + "px";
        } else {
            tooltip.style.top = rect.bottom + "px";
        }
        tooltip.style.display = "block";
        if (stateTooltip && !stateTooltip.classList.contains('static')) {
            stateTooltip.style.display = ""; // often gets in the way
        }
    });
    element.addEventListener("mouseout", (event: MouseEvent) => {
        tooltip.style.top = "";
        tooltip.style.bottom = "";
        tooltip.style.left = "";
        tooltip.style.right = "";
        tooltip.style.display = "";
    });
}

if (page && tooltip) {
    Object.keys(descriptions).forEach(id => {
        // we have extended features duplicate ids from regular features (I know, bad), so we have to select all
        // @flow-ignore: flow does not seem to be aware of CSS API yet (https://github.com/facebook/flow/issues/8073)
        const listOfElements = document.querySelectorAll("#" + CSS.escape(id));
        if (!listOfElements.length && !allowMissing.includes(id)) {
            console.error(`${id} not on page.`);
        }
        listOfElements.forEach(e => createTooltipForElement(e, descriptions[id]));
    });
} else {
    console.error("page or tooltip element is missing from page");
}

// establish message listener for dynamic tooltips
pubsub.subscribe('tooltip:show', ({element, message}) => {
    showTooltipForElement(element, message)
})

pubsub.subscribe('tooltip:hide', () => {
    tooltip.style.display = 'none'
})
